// Import shared services
import baseClient from './base.client.service';
import tealiumService from './tealium.service';
import baseSixtyFour from './basesixtyfour.service';
// Import parcels shared services
import trackingService from './parcels/tracking.service';
import requestInterceptor from './parcels/request.interceptor';
import parcelsService from './parcels/parcels.service';

/* @ngInject */
const parcelsModule = angular.module('parcelsModule', [])
  .factory('baseClient', baseClient)
  .factory('trackingService', trackingService)
  .factory('requestInterceptor', requestInterceptor)
  .service('baseSixtyFour', baseSixtyFour)
  .service('tealiumService', tealiumService)
  .service('parcelsService', parcelsService)
  .config(['$httpProvider', ($httpProvider) => {

    $httpProvider.interceptors.push('requestInterceptor');

  }]);

export default parcelsModule.name;



// WEBPACK FOOTER //
// ./src/angular-services/parcels.module.js